module.exports = __webpack_public_path__ + "static/media/backToHome.48b484bc.svg";